// Pure helpers for fitting the map to a set of artworks. No Leaflet here so
// this stays testable under vitest's node environment.

// The Google-era fitBounds capped the resulting zoom at 15 so a single art or a
// tight group never opens on a rooftop. Leaflet takes this as fitBounds' maxZoom.
export const MAX_FIT_ZOOM = 15

// Where the map opens when nothing is filtered. The collection is worldwide
// (Hawaii, Tokyo, Sydney, Cape Town...), so fitting every art gives a z1 globe
// where nothing is legible. Almost all of it is in the Americas and Europe;
// this frames those, and the outliers are one zoom-out away.
//
// The latitude span is the tight constraint: Mercator stretches the poles, so
// reaching further north or south than this forces a whole zoom level out on
// the ~600px-tall map the SPA renders. These values fit at z2.5 there.
export const HOME_BOUNDS = [
  [-45, -130], // south-west: below Buenos Aires / west of Vancouver
  [66, 40],    // north-east: Reykjavik's latitude / eastern Europe
]

const coord = value => {
  const n = typeof value === 'number' ? value : parseFloat(value)
  return Number.isFinite(n) ? n : null
}

/**
 * Returns [[south, west], [north, east]] covering every item with usable
 * coordinates, or null when there is none. Leaflet's fitBounds accepts this
 * literal array directly.
 */
export function boundsFor(items) {
  if (!items || !items.length) return null

  let south = Infinity, west = Infinity, north = -Infinity, east = -Infinity
  let any = false

  for (const item of items) {
    const lat = coord(item && item.lat)
    const lng = coord(item && item.lng)
    if (lat === null || lng === null) continue
    any = true
    if (lat < south) south = lat
    if (lat > north) north = lat
    if (lng < west) west = lng
    if (lng > east) east = lng
  }

  return any ? [[south, west], [north, east]] : null
}
